/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\BrandSVG\MINI.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday March 10th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday March 10th 2023 5:16:50 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from 'Content/SVG/SVGProps';

function MINI(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path d="M540,333.8c-70.4,.01-135.92,35.93-173.79,95.28H69.76l29.51,29.51h251.54c-4.78,11.11-8.57,22.61-11.33,34.39H133.66l29.15,29.15h171.91c-.56,5.94-.87,11.91-.92,17.88,.05,5.51,.33,11.02,.82,16.51H197.19l29.15,29.15h112.76c2.61,11.76,6.25,23.26,10.88,34.38h-89.25l29.5,29.52h75.37c37.66,60.04,103.51,96.53,174.39,96.63,70.88-.1,136.74-36.59,174.4-96.63h75.36l29.52-29.52h-89.25c4.62-11.12,8.26-22.62,10.88-34.38h112.76l29.15-29.15h-137.43c.5-5.49,.77-11,.82-16.51-.04-5.97-.35-11.94-.91-17.88h171.91l29.15-29.15h-205.83c-2.76-11.77-6.54-23.28-11.32-34.39h251.53l29.52-29.51h-296.45c-37.87-59.34-103.39-95.26-173.79-95.28h0Zm0,27.95c98.44,0,178.25,79.8,178.25,178.25s-79.8,178.25-178.25,178.25c-98.44,0-178.25-79.8-178.25-178.24h0c0-98.45,79.8-178.25,178.25-178.25,0,0,0,0,0,0h0Zm-141.8,132.04v92.4h19.27v-72.73l20.33,72.73h19.96l20.4-72.73v72.73h19.27v-92.4h-31.11l-18.43,63.03-18.64-63.03h-31.05Zm119.34,0v92.4h20.74v-92.4h-20.74Zm40.64,0v92.4h19.27v-60.25l41.42,60.25h20.82v-92.4h-19.27v61.71l-42.05-61.71h-20.18Zm102.87,0v92.4h20.74v-92.4h-20.74Z"/>
        </svg>
    );
}

export default MINI;
